enum ECorrectionsTab {
  PAYMENTS = 'payments',
  LICENSES = 'licenses',
  TARIFFS = 'tariffs',
}

export {ECorrectionsTab};
